import { render, staticRenderFns } from "./CandidateProfile.vue?vue&type=template&id=d9e0b17e&"
import script from "./CandidateProfile.vue?vue&type=script&lang=ts&"
export * from "./CandidateProfile.vue?vue&type=script&lang=ts&"
import style0 from "./CandidateProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QSeparator});
